import { render, staticRenderFns } from "./TheFormProducts1.vue?vue&type=template&id=4a4f169f&scoped=true&"
import script from "./TheFormProducts1.vue?vue&type=script&lang=ts&"
export * from "./TheFormProducts1.vue?vue&type=script&lang=ts&"
import style0 from "./TheFormProducts1.vue?vue&type=style&index=0&id=4a4f169f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f169f",
  null
  
)

export default component.exports